import React from "react"

import {EntityType} from "../../../gd/const/item"
import {SpaceProto} from "../../../model2/space/space-proto"
import Workspace from "../../../model2/space/workspaces/workspace"
import {selectParent_recursiveUpdateExpandState} from "../../../gd-ui/select-parent-new/actions/filter"
import SelectParent_Popover from "../../../gd-ui/select-parent-new/components/popover/popover"
import {SelectParent_Props} from "../../../gd-ui/select-parent-new/@types"
import {SelectParent_RenderType} from "../../../gd-ui/select-parent-new/@const"
import {ITreeSelectorParent} from "../../../gd-ui/select-parent-new/components/tree-new/project-tree-new";

const MIN_SEARCH_TEXT_LENGTH = 2

type Props = SelectParent_Props & {
    className?          : string

    parentProjectId?    : ID
    parentsFor          : EntityType

    noHeader?           : boolean

    onClickProject      : {(projectId:ID):void}
    onClose             : func
}

type State = {
    search          : string
    isSearching     : boolean
}

export default class ProjectFinder extends React.Component<Props, State> implements ITreeSelectorParent {

    public spaces               : SpaceProto[]

    public selectedProjects     : ID[] = []
    public multiselect          : boolean = false

    static defaultProps = {
        parentsFor  : EntityType.PROJECT,
        canBeNull   : false,
        renderType  : SelectParent_RenderType.INLINE_EDITABLE,
        placeholder : ''
    }

    constructor(props: Props) {
        super(props)

        this.state = {
            search          : '',
            isSearching     : false,
        }

        this.spaces = _.filter(gd.spaces.spacesWithProjects, (space: SpaceProto) => space.enabled)

        this._updateInitialExpand()
    }

    // Interface method
    get parentsFor():EntityType {
        return this.props.parentsFor
    }

    _updateInitialExpand() {
        // expand workspaces
        _.map(this.spaces, (space: SpaceProto) => {
            const project = (space as Workspace).project
            if (project) {
                project.treeIsExpandedProjectSelector = false
            }

            // update initial expand state for each project
            selectParent_recursiveUpdateExpandState(
                space,
                // this.state.selectedProjectId ? [this.state.selectedProjectId] : undefined,
                // this.props.availableProjects
            )
        })
    }

    onSearchChange = (value: string) => {
        // restore expanded projects if search string is empty
        if (!value) {
            this._updateInitialExpand()
        }

        const isSearching = value.length >= MIN_SEARCH_TEXT_LENGTH
        if (this.state.search && !value) {
            this.onSearchCancel()
        } else {
            this.setState({
                search      : value,
                isSearching : isSearching
            })
        }
    }

    onSearchCancel = () => {
        this.setState({
            isSearching : false,
            search      : ''
        })
    }

    hidePopover = () => {
        this.onClose()
    }

    onNewProjectClick = () => {}

    onClose = () => {if(this.props.onClose) this.props.onClose()}

    render() {
        const classes = Classes("flex-column-left-top", this.props.className)

        return (
            <div className={classes}>
                <div className="header h-70 w-100-percent">
                    <div className="title">Select a project</div>
                    <div className="i5-delete" onClick={this.props.onClose}/>
                </div>

                <div className="gd-select-parent-popover-new">
                    <SelectParent_Popover parentSelector    = {this}
                                          onParentSelected  = {this.props.onClickProject}/>
                </div>

                {/*<ProjectFinderMain spaces           = {this.spaces}
                                   isSearching      = {this.state.isSearching}
                                   parentProjectId  = {this.props.parentProjectId}
                                   parentsFor       = {this.props.parentsFor}
                                   search           = {this.state.search}
                                   onClickProject   = {this.props.onClickProject}/>*/}
            </div>
        )
    }
}